import React from "react";

interface ToggleSwitchProps {
  isOn?: boolean;
  onToggle: () => void;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  isOn = false,
  onToggle,
}) => {
  return (
    <div
      onClick={onToggle}
      className={`w-16 h-8 flex items-center cursor-pointer border-2
        rounded-xl
        ${isOn ? "bg-primary border-primary" : "bg-gray-400 border-gray-400"}
        transition-colors duration-300 select-none`}
      role="switch"
      aria-checked={isOn}
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onToggle();
        }
      }}
    >
      <div
        className={`w-7 h-7 bg-white rounded-full shadow-md transition-all duration-300
          ${isOn ? "ml-1" : "ml-auto mr-1"}`}
      />
    </div>
  );
};

export default ToggleSwitch;
